import { connect } from 'react-redux'

import BannerSection from 'components/home-page/views/sections/banner'

const mapStateToProps = (state, ownProps) => ({
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(BannerSection)
